export const STATUSES = {
  registered: 'Registrada',
  modified: 'Modificada',
  cancelled: 'Cancelada'
};
